/**
 * Parse a Stream Chat channel id/CID and extract the masterProfileId for
 * master-circle channels. Channel ids look like `master-circle-{id}`;
 * CIDs look like `messaging:master-circle-{id}`.
 *
 * Returns null if the channel is not a master-circle channel or the id
 * portion isn't numeric.
 */
export function parseMasterProfileIdFromChannel(channelOrId: any): number | null {
  if (!channelOrId) return null;

  const raw: string | undefined =
    typeof channelOrId === 'string'
      ? channelOrId
      : channelOrId.id ?? channelOrId.cid;
  if (!raw) return null;

  // Drop the channel-type prefix in CIDs.
  const id = raw.includes(':') ? raw.split(':').slice(1).join(':') : raw;
  const m = id.match(/^master-circle-(\d+)$/);
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return Number.isFinite(n) ? n : null;
}
